import { HttpCodes } from '@space-core/constants'
import { apiSparkleSecurity, requester } from '@space-shell/config/request'
import type { RequestHeaders } from '@space-shell/config/request/manager'

import { UserEndpoints } from './constants'
import type { GetUserInfoParams, UserInfo } from './types'

class UserService {
  static getInfo = async (params: GetUserInfoParams) => {
    const response = await requester.get<UserInfo>(UserEndpoints.getInfo(params), {
      params: {
        dimensions: '48x48'
      }
    })

    return response.data
  }

  static joinProducts = async (productId: string) => {
    const headers: RequestHeaders = {
      'x-product-id': productId,
      'content-type': 'application/json'
    }
    const { status } = await requester.post<number>(UserEndpoints.join(), null, { headers })

    return status
  }

  static createProfile = async (token: string, expiresAt: number) => {
    const msToSeconds = 1000
    const dateInSeconds = Math.floor(new Date().getTime() / msToSeconds)
    const unauthorizedStatusCode = HttpCodes.UNAUTHORIZED

    if (expiresAt > dateInSeconds) {
      const { status } = await apiSparkleSecurity.post<number>(
        UserEndpoints.create(),
        {},
        {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
      )

      return status
    }

    return unauthorizedStatusCode
  }
}

export default UserService
